<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Candidate Details</v-toolbar-title>
    </v-toolbar>
    <!-- <v-layout row wrap v-if="project">
      <v-flex md6 class="pa-4">
        <div v-for="prop in leftItems">
          <strong>{{ prop.title }}</strong
          ><br />
          <p>{{ renderProp(prop) }}</p>
        </div>
      </v-flex>
      <v-flex md6 class="pa-4">
        <div v-for="prop in rightItems">
          <strong>{{ prop.title }}</strong
          ><br />
          <p>{{ renderProp(prop) }}</p>
        </div>
      </v-flex>
    </v-layout> -->
    <div v-if="project" class="pa-4">
      <v-layout row wrap>
        <v-flex md3>
          <strong>Applied Country</strong><br />
          <p>{{ project.applied_country }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Profession</strong><br />
          <p>{{ project.profession }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Name</strong><br />
          <p>{{ project.name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Father's Name</strong><br />
          <p>{{ project.mother_name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Mother's Name</strong><br />
          <p>{{ project.father_name }}</p>
        </v-flex>
      </v-layout>

      <u>Present Address:</u>
      <v-layout row wrap>
        <v-flex md3>
          <strong>District</strong><br />
          <p>{{ valueToText(districtTV(), project.present_district) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.S</strong><br />
          <p>{{ valueToText(upazilaTV(), project.present_upazila) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.O</strong><br />
          <p>{{ valueToText(unionTV(), project.present_union) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Vill</strong><br />
          <p>{{ project.present_village }}</p>
        </v-flex>
      </v-layout>

      <u>Permanent Address:</u>
      <v-layout row wrap>
        <v-flex md3>
          <strong>District</strong><br />
          <p>{{ valueToText(districtTV(), project.permanent_district) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.S</strong><br />
          <p>{{ valueToText(upazilaTV(), project.permanent_upazila) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>P.O</strong><br />
          <p>{{ valueToText(unionTV(), project.permanent_union) }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Vill</strong><br />
          <p>{{ project.permanent_village }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Passport number</strong><br />
          <p>{{ project.passport_number }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Issue Date</strong><br />
          <p>{{ project.passport_issue_date }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Expiry Date</strong><br />
          <p>{{ project.passport_exp_date }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Date of Birth</strong><br />
          <p>{{ project.dob }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Age</strong><br />
          <p>{{ project.age }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>NID Number</strong><br />
          <p>{{ project.nid_number }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Nationality</strong><br />
          <p>{{ project.nationality }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Birth Certificate</strong><br />
          <p>{{ project.birth_cert_number }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Gender</strong><br />
          <p>{{ project.gender }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Religion</strong><br />
          <p>{{ project.religion }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Marital Status</strong><br />
          <p>{{ project.marital_status }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Height</strong><br />
          <p>{{ project.height }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Weight</strong><br />
          <p>{{ project.weight }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Expert in Language</strong><br />
          <p>{{ project.language_proficiency }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Educational Qualification</strong><br />
          <p>{{ project.educational_qualification }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Work Exp</strong><br />
          <p>{{ project.working_experience }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Type of Work Exp</strong><br />
          <p>{{ project.working_experience_type }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Mobile Number</strong><br />
          <p>{{ project.mobile }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Family Mobile Numbe</strong><br />
          <p>{{ project.family_mobile_number }}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md12>
          <strong>Notes</strong><br />
          <p>{{ project.notes }}</p>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  MEDICAL_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
} from "../../mdsir/const";

import {
  valueToText,
  getTV,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["project"],
  data() {
    return {
      leftItems: [
        { title: "Name", key: "name" },
        { title: "Gender", key: "gender" },
        { title: "Passport", key: "passport_number" },
        { title: "NID", key: "nid_number" },
        { title: "Date of Birth", key: "dob" },
        { title: "Mobile", key: "mobile" },
        { title: "Email", key: "email" },
        { title: "Address", key: "address" },
        { title: "Training Start Date", key: "training_start_date" },
        { title: "Training End Date", key: "training_end_date" },
        { title: "Finger Status", key: "finger_status" },
        { title: "Notes", key: "notes" },
      ],
      rightItems: [
        { title: "Project Owner", key: "project_owner" },
        { title: "Contract Date", key: "contract_date" },
        { title: "Service Type", key: "service_type" },
        { title: "Flight Date", key: "flight_date" },
        { title: "Medical Date", key: "medical_date" },
        { title: "Medical Status", key: "medical_status" },
        { title: "Trade Name", key: "trade_name" },
        { title: "MOFA Date", key: "mofa_date" },
        { title: "MOFA Number", key: "mofa_number" },
        { title: "Visa Issue Date", key: "visa_issue_date" },
        { title: "Visa Number", key: "visa_number" },
        { title: "Visa ID Number", key: "visa_id_number" },
      ],
    };
  },

  // computed: {},

  methods: {
    renderProp(item) {
      const { key } = item;
      let value = this.project[key];
      switch (key) {
        case "medical_status":
          value = value ? valueToText(MEDICAL_STATUSES, value) : "";
          break;
        case "service_type":
          value = value ? valueToText(SERVICE_TYPES, value) : "";
          break;
        case "trade_name":
          value = value ? valueToText(VISA_TYPES, value) : "";
          break;
        case "project_owner":
          value = value ? valueToText(PROJECT_OWNER, value) : "";
          break;

        default:
          break;
      }
      return value;
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
